import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { startConsoleCapture } from './utils/consoleCapture'

// КРИТИЧНО: перехват консоли запускается ДО монтирования React.
// Ошибки во время инициализации модулей / React render попадают в IndexedDB.
startConsoleCapture()

// Очищаем флаг force-update если остался с прошлого reload
if (localStorage.getItem('sw_force_update_in_progress')) {
  localStorage.removeItem('sw_force_update_in_progress')
}

// НЕ добавляем свой controllerchange listener!
// vite-plugin-pwa с registerType:'autoUpdate' уже имеет встроенный
// controllerchange → reload в сгенерированном virtual:pwa-register коде.
// Добавление второго listener создаёт бесконечный цикл перезагрузок.

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
